import React from 'react';
export function DetailPageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-3319">
      {/* Back button and actions */}
      <div className="flex items-center justify-between" data-id="element-3320">
        <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-3321" />
        <div className="h-10 w-28 bg-gray-200 rounded-md" data-id="element-3322" />
      </div>
      {/* Main info card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3323">
        <div className="flex items-start gap-4 mb-6" data-id="element-3324">
          <div className="w-16 h-16 bg-gray-200 rounded-full" data-id="element-3325" />
          <div className="flex-1" data-id="element-3326">
            <div className="h-8 w-64 bg-gray-200 rounded mb-3" data-id="element-3327" />
            <div className="space-y-2" data-id="element-3328">
              <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-3329" />
              <div className="h-4 w-40 bg-gray-200 rounded" data-id="element-3330" />
              <div className="h-4 w-56 bg-gray-200 rounded" data-id="element-3331" />
            </div>
          </div>
          <div className="h-6 w-20 bg-gray-200 rounded-full" data-id="element-3332" />
        </div>
        {/* Stats */}
        <div className="pt-6 border-t border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3333">
          {[1, 2, 3].map(i => <div key={i} data-id="element-3334">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2" data-id="element-3335" />
              <div className="h-8 w-32 bg-gray-200 rounded" data-id="element-3336" />
            </div>)}
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-3337">
        <div className="border-b border-gray-200 flex gap-8 px-6" data-id="element-3338">
          {[1, 2, 3].map(i => <div key={i} className="py-4" data-id="element-3339">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-3340" />
            </div>)}
        </div>
        {/* Tab content */}
        <div className="p-6 space-y-4" data-id="element-3341">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="border border-gray-200 rounded-lg p-4" data-id="element-3342">
              <div className="flex justify-between items-center" data-id="element-3343">
                <div className="flex-1 space-y-2" data-id="element-3344">
                  <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-3345" />
                  <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-3346" />
                </div>
                <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-3347" />
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}